import React, { Component } from 'react';
import { connect } from 'react-redux';
import { path } from 'ramda';
import { push } from 'react-router-redux';
import Breadcrumbs from '../../common/Breadcrumbs';
import ConfirmAction from '../../common/ConfirmAction';
import { changeModalState } from '../../actions/modal';
import { deleteObject } from '../../actions/objectToDelete';
import {
  fetchAllData,
  reOrderStages, toggleStages,
} from '../../api/boardSettings';
import { removeLane, refreshLane, } from '../../api/boardLane';
import { removeStage, refreshStage, } from '../../api/boardStage';
import {
  getLastOrder,
  getItemByOrder,
} from '../../utils/order';
import Preloader from '../../common/Preloader';
import $ from 'jquery';
import hasAccess from "../../helpers/permissionChecker";

export class BoardSettings extends Component {

  constructor(props) {
    super(props);
    this.renderLanes = this.renderLanes.bind(this);
    this.renderStages = this.renderStages.bind(this);
    this.addLane = this.addLane.bind(this);
    this.addStage = this.addStage.bind(this);
    this.removeLaneById = this.removeLaneById.bind(this);
    this.editLaneById = this.editLaneById.bind(this);
    this.removeStageById = this.removeStageById.bind(this);
    this.editStageById = this.editStageById.bind(this);
  }

  componentWillMount() {
    this.props.getData();
  }

  addPopover(container) {
    container.popover({
      placement: "bottom",
      trigger: "hover",
    });
  }

  deletePopover(container) {
    container.popover('dispose');
  }

  componentWillUnmount() {
    this.deletePopover($('.button-has-popover'));
  }

  componentDidUpdate() {
    const menuOption = $('.button-has-popover');
    this.deletePopover(menuOption);
    this.addPopover(menuOption);
  }

  removeLaneById(id) {
    this.props.handleObjectToDelete({
      id: parseInt(id),
      handler: removeLane,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'removeLane',
    });
  }

  editLaneById(id) {
    this.props.moveToEditLane(id);
  }

  removeStageById(id) {
    this.props.handleObjectToDelete({
      id: parseInt(id),
      handler: removeStage,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'removeStage',
    });
  }

  editStageById(id) {
    this.props.moveToEditStage(id);
  }

  renderLanes() {
    const lanes = [];
    const lanesList = path(['boardSettings', 'lanes'], this.props);

    if (!lanesList) {
      return null;
    }

    for (let i = 0; i < lanesList.length; i++) {
      lanes.push(
        <div className="card rounded" style={{ padding: '10px', margin: '5px' }} key={i}>
          <div className="pull-left">
            <span style={{
              position: 'relative',
              top: '8px',
              left: '10px',
            }}><b>{lanesList[i].label}</b> - <i>{lanesList[i].description}</i></span>
            <button
              data-content='edit'
              className="button-has-popover btn btn-rounded btn-icon ui-btn pull-right"
              style={{ borderRadius: '4px', marginLeft: '8px' }}
              onClick={() => { this.editLaneById(lanesList[i].id) }}
            >
              <i className="fa fa-pencil" style={{ margin: '0px' }}></i>
            </button>

            {hasAccess({
              'permAreaKey': 'boardSettings',
              'permTypeKey': 'delete',
              'idForCheckingAuthor': lanesList[i].user_id
            }) &&
            <button
              data-content='remove'
              className="button-has-popover btn btn-rounded btn-icon ui-btn pull-right"
              style={{ borderRadius: '4px', marginLeft: '8px' }}
              onClick={() => { this.removeLaneById(lanesList[i].id) }}
            >
              <i className="fa fa-remove" style={{ margin: '0px', }}></i>
            </button>
            }
          </div>
        </div>
      );
    }

    return lanes;
  }

  renderStages() {
    const stages = [];
    const stagesList = path(['boardSettings', 'stages'], this.props);

    if (!stagesList) {
      return null;
    }

    for (let i = 0; i < stagesList.length; i++) {
      let currentStage = stagesList[i];
      let showOnDashboard = (
        <input
          type="checkbox"
          checked={currentStage.show_on_dashboard}
          data-content='show on dashboard'
          className="button-has-popover btn btn-rounded btn-icon ui-btn pull-right"
          style={{ borderRadius: '4px', marginLeft: '8px' }}
          onClick={() => { this.toggleStage(currentStage.id, 'show_on_dashboard', currentStage); }}
        />
      );
      let showOnTimeTracking = (
        <input
          type="checkbox"
          checked={currentStage.show_on_time_tracking}
          data-content='show on time tracking'
          className="button-has-popover btn btn-rounded btn-icon ui-btn pull-right"
          style={{ borderRadius: '4px', marginLeft: '8px' }}
          onClick={() => { this.toggleStage(currentStage.id, 'show_on_time_tracking', currentStage); }}
        />
      );
      let downButton = (
        <button
          data-content='move down'
          className="button-has-popover btn btn-rounded btn-icon ui-btn pull-right"
          style={{ borderRadius: '4px', marginLeft: '8px' }}
          onClick={() => { this.moveTo(currentStage.order, 'down', currentStage); }}
        >
          <i className="fa fa-arrow-down" style={{ margin: '0px', }}></i>
        </button>
      );
      let upButton = (
        <button
          data-content='move up'
          className="button-has-popover btn btn-rounded btn-icon ui-btn pull-right"
          style={{ borderRadius: '4px', marginLeft: '8px' }}
          onClick={() => { this.moveTo(currentStage.order, 'up', currentStage); }}
        >
          <i className="fa fa-arrow-up" style={{ margin: '0px', }}></i>
        </button>
      );
      let removeButton = (
        <button
          data-content='remove'
          className="button-has-popover btn btn-rounded btn-icon ui-btn pull-right"
          style={{ borderRadius: '4px', marginLeft: '8px' }}
          onClick={() => { this.removeStageById(stagesList[i].id) }}
        >
          <i className="fa fa-remove" style={{ margin: '0px', }}></i>
        </button>
      );
      let editButton = (
        <button
          data-content='edit'
          className="button-has-popover btn btn-rounded btn-icon ui-btn pull-right"
          style={{ borderRadius: '4px', marginLeft: '8px' }}
          onClick={() => { this.editStageById(stagesList[i].id) }}
        >
          <i className="fa fa-pencil" style={{ margin: '0px' }}></i>
        </button>
      );
      if (currentStage.order !== undefined) {
        if (currentStage.order == 1) {
          upButton = null;
          downButton = null;
          removeButton = null;
          editButton = null;
        } else if (currentStage.order == 2) {
          upButton = null;
        }
        stages[currentStage.order] = (
          <div className="card rounded" key={i} style={{ padding: '10px', margin: '5px', minHeight: '56px', }}>
            <div className="pull-left">
              <span style={{ position: 'relative', top: '8px', left: '10px', }}><b>{currentStage.label}</b></span>
              {hasAccess({
                'permAreaKey': 'boardSettings',
                'permTypeKey': 'move',
                'idForCheckingAuthor': currentStage.user_id
              }) &&
              downButton}
              {hasAccess({
                'permAreaKey': 'boardSettings',
                'permTypeKey': 'move',
                'idForCheckingAuthor': currentStage.user_id
              }) && upButton}
              {hasAccess({
                'permAreaKey': 'boardSettings',
                'permTypeKey': 'view',
                'idForCheckingAuthor': currentStage.user_id
              }) && editButton}
              {hasAccess({
                'permAreaKey': 'boardSettings',
                'permTypeKey': 'delete',
                'idForCheckingAuthor': currentStage.user_id
              }) && removeButton}
              {hasAccess({
                  'permAreaKey': 'boardSettings',
                  'permTypeKey': 'move',
                  'idForCheckingAuthor': currentStage.user_id
                }) &&
                showOnDashboard}
              {hasAccess({
                  'permAreaKey': 'boardSettings',
                  'permTypeKey': 'move',
                  'idForCheckingAuthor': currentStage.user_id
                }) &&
                showOnTimeTracking}
            </div>
          </div>
        );
      }
    }

    return stages;
  }

  addLane() {
    this.props.moveToAddLane();
  }

  addStage() {
    this.props.moveToAddStage();
  }

  toggleStage(currentOrder, item, currentStage) {
    if (currentStage[item]) {
      this.props.toggleStage({
        stage_id: currentOrder,
        type: item,
        value: 0
      })
    } else {
      this.props.toggleStage({
        stage_id: currentOrder,
        type: item,
        value: 1
      })
    }
  }

  moveTo(currentOrder, destination, item) {
    const stagesList = path(['boardSettings', 'stages'], this.props) || [];
    if (destination == 'up' && currentOrder !== 2) {
      let prevOrder = parseInt(currentOrder) - 1;
      let prevItem = getItemByOrder(stagesList, 'order', prevOrder);
      this.props.swapStage({
        stage_a_id: item.id,
        stage_b_id: prevItem.id,
      });
    } else if (destination == 'down' && currentOrder !== getLastOrder(stagesList, 'order')) {
      let nextOrder = parseInt(currentOrder) + 1;
      let nextItem = getItemByOrder(stagesList, 'order', nextOrder);
      this.props.swapStage({
        stage_a_id: item.id,
        stage_b_id: nextItem.id,
      });
    }
  }

  render() {
    const lanes = this.renderLanes();
    const stages = this.renderStages();
    let preloaderStages = null;
    let preloaderLanes = null;

    if (!lanes) {
      preloaderLanes = (
        <Preloader
          show={true}
          type={'circle'}
        />
      );
    }

    if (!stages) {
      preloaderStages = (
        <Preloader
          show={true}
          type={'circle'}
        />
      );
    }
    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { icon: 'settings', name: 'Board Settings' },
        ]}/>
        <div className="card rounded">
          <div className="card-header rounded-top">
            Board Editor
          </div>
          <div className="card-block">
            {hasAccess({ 'permAreaKey': 'boardSettings', 'permTypeKey': 'create' }) &&
            <div className="clearfix mb-3">
              <button
                className="btn btn-rounded btn-icon ui-btn pull-right"
                onClick={this.addStage}
                style={{ borderRadius: '4px', marginLeft: '10px' }}
              >
                <i className="material-icons">add_circle_outline</i>
                <span className="color-default">Add Stage</span>
              </button>
              <button
                className="btn btn-rounded btn-icon ui-btn pull-right"
                onClick={this.addLane}
                style={{ borderRadius: '4px' }}
              >
                <i className="material-icons">add_circle_outline</i>
                <span className="color-default">Add Location</span>
              </button>
            </div>
            }
            <div className="row">
              <div className="col card rounded" style={{ paddingTop: '20px', paddingBottom: '25px' }}>
                {lanes}
                {preloaderLanes}
              </div>
              <div className="col card rounded"
                   style={{ marginLeft: '10px', paddingTop: '20px', paddingBottom: '25px' }}>
                {stages}
                {preloaderStages}
              </div>
            </div>
            <ConfirmAction id={'removeLane'}/>
            <ConfirmAction id={'removeStage'}/>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    getData: () => {
      fetchAllData()(dispatch);
    },
    swapStage: (data) => {
      reOrderStages(data)(dispatch);
    },
    toggleStage: (data) => {
      toggleStages(data)(dispatch)
    },
    moveToAddLane: () => {
      dispatch(push('/pages/add-lane'));
    },
    moveToAddStage: () => {
      dispatch(push('/pages/add-stage'));
    },

    removeLane: (data) => {
      removeLane(data)(dispatch);
    },
    editLaneBy: (data) => {
      refreshLane(data)(dispatch);
    },
    removeStage: (data) => {
      removeStage(data)(dispatch);
    },
    editStage: (data) => {
      refreshStage(data)(dispatch);
    },

    moveToEditLane: (id) => {
      dispatch(push('/pages/lane-edit/' + id));
    },
    moveToEditStage: (id) => {
      dispatch(push('/pages/stage-edit/' + id));
    },

    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BoardSettings);



// WEBPACK FOOTER //
// ./src/containers/BoardSettings/index.js